'use client'

import { Image as DatoImage } from 'react-datocms'
import { useParams } from 'next/navigation'
import { Button, RightTopArrow } from '@desoutter/uikit'
import { BlogUsecasesCardFragment } from './BlogUsecasesCard.generated'
import { LocalizedLink } from '@/components/LocalizedLink'

type BlogUsecasesCardProps = {
	fragment: BlogUsecasesCardFragment
}

export default function BlogUsecasesCard({ fragment }: BlogUsecasesCardProps) {
	const { lang } = useParams()
	return (
		<LocalizedLink
			locale={lang}
			prefetch={false}
			href={`/articles/${fragment.relatedArticle.slug}`}
			title={fragment.title}
		>
			<div className="relative w-screen sm:w-[420px] sm:h-[570px] pr-8 sm:pr-0 text-foreground gap-5">
				<DatoImage
					layout="responsive"
					objectFit="cover"
					data={fragment.image.responsiveImage}
					className="rounded-2xl"
				/>

				<div className="absolute top-5 left-5 flex flex-row z-10 gap-2">
					<DatoImage
						data={fragment?.authorPicture?.responsiveImage}
						className="rounded-full"
					/>
					<div>
						<p className="font-bold">
							{fragment.authorFirstname} {fragment.authorLastname.toUpperCase()}
						</p>
						<p className="text-sm italic">
							{fragment.authorJob ?? ''} @${fragment.company}
						</p>
					</div>
				</div>

				<Button
					size="xl"
					name="go to usecase"
					color="tertiary"
					title="go to usecase"
					icon={RightTopArrow}
					className="absolute top-4 right-12 sm:right-4"
				/>

				<div className="absolute bottom-4 left-8 flex flex-col w-[380px]">
					<h3 className="h5">{fragment.title}</h3>
				</div>
			</div>
		</LocalizedLink>
	)
}
